//@ts-nocheck
import React, { useEffect, useState } from 'react';
import BaseJobList from './BaseJobList';
import Sidebar from './Sidebar';
import { useSidebar } from '../../context/SidebarContext';
import { useLocation, useParams } from 'react-router-dom';
import ManageJob from './ManageJob';
import JobsListing from '../../pages/JobsListing';
import { baseSwitchMemberDetailsData } from '../../features/base/baseSlice';
import { useAppDispatch } from '../../app/hooks';


interface UserDetails {
    id: number;
}

interface DashboardLayoutProps {
    children: ReactNode;
    userDetails: UserDetails;
}

const JobHomeLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const { verticleSidebar, setVerticleSidebar } = useSidebar();
    const location = useLocation();
    const { baseId, jobId } = useParams<{ baseId: string, jobId: string }>();
    const [baseSwitchData, setbaseSwitchData] = useState<any>(null);
    const pathname = location.pathname;
    const dispatch = useAppDispatch();
    // Check which view to render
    const isDashboard = pathname === `/${baseId}/dashboard`;
    const isJobs = pathname === `/${baseId}/jobs`;


    useEffect(() => {
        if (baseId) {
            const fetchData = async () => {
                const storedBaseMember = localStorage.getItem('baseSwitchDetails');
                if (storedBaseMember) {                    
                    setbaseSwitchData(JSON.parse(storedBaseMember));
                } else {
                    try {
                        const baseResponse = await dispatch(baseSwitchMemberDetailsData(baseId));
                        localStorage.setItem('baseSwitchDetails', JSON.stringify(baseResponse.payload?.data?.base))
                        setbaseSwitchData(baseResponse.payload?.data?.base);
                    } catch (error) {
                        console.error("Error fetching base member details:", error);
                    }
                }
            };
            fetchData();
        }
    }, [baseId, dispatch]);



    return (
        <div className="h-[calc(100vh_-_0rem)] bg-zinc-100">
            <div className='h-full'>
                <Sidebar baseSwitchData={baseSwitchData} />
                <div className='mt-[52px]'>
                    <div className='bg-white w-full h-full'></div>
                    <div className={`${verticleSidebar ? 'lg:pl-[232px]' : 'pl-[59px] rounded-tr-lg rounded-bl-lg'} pr-[8px] mt-[1px] mb-2 pt-[2px] 
                     transition-all duration-300 h-[calc(100vh_-_59px)]`}>
                        <main className={`p-0 bg-white min-h-[calc(100vh_-62px)] h-auto pb-0 mr-[1px] mb-[1px] rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-lg`}>
                            <div className='w-full h-full'>
                                {isDashboard && <BaseJobList />}
                                {isJobs && <JobsListing />}
                                {/* {isJobs && <ManageJob />} */}
                            </div>
                        </main>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default JobHomeLayout;
